import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  footerContainer: {
    display: "flex",
    flexDirection: "column",
    minHeight: "95vh",
    margin: "0 30px",
    position: "relative",
  },
  content: {
    minHeight: "calc(100vh - 100px)",
    flex: "1 0 auto",
  },
  footer: {
    flexShrink: 0,
    width: "100%",
    position: "absolute",
    height: "50px",
  },
});

export default useStyles;
